import { useState } from 'react'
import {
  CustomContainedButton,
  DocumentScan,
  Translate,
} from '@innovatrics/checkin-components'
import {
  Typography,
  FormControlLabel,
  Checkbox,
  Grid,
  Link,
  Box,
  useMediaQuery,
} from '@mui/material'

interface CheckinIntroductionProps {
  buttonState: boolean
  initializeCheckin: () => void
  hotelName?: string
}

export const CheckinIntroduction = ({
  buttonState,
  initializeCheckin,
  hotelName,
}: CheckinIntroductionProps) => {
  const matches = useMediaQuery('(min-width:750px)')
  const [checkboxState, setCheckboxState] = useState<boolean>(false)
  return (
    <Grid
      container
      justifyContent={'center'}
      flexDirection={'column'}
      maxWidth={matches ? '750px' : 'calc(100vw - 35px)'}
      gap={'12px'}
      margin={'0 auto'}
    >
      <Grid item>
        <Grid
          container
          justifyContent={'center'}
          marginTop={matches ? '55px' : '30px'}
        >
          <Box width={matches ? '115px' : '95px'}>
            <DocumentScan />
          </Box>
        </Grid>
      </Grid>
      <Typography
        align="center"
        color="secondary"
        fontSize={matches ? '24px' : '20px'}
        fontWeight={600}
      >
        {hotelName} 
        <Translate
          entityName={'customer.introduction.subtitle'}
          defaultMessage={'send you an online check-in form.'}
        />
      </Typography>
      <Typography align="center" fontSize={'14px'} fontWeight={400}>
        <Translate
          entityName={'customer.introduction.text'}
          defaultMessage={
            'Vysvetlenie co budes robit na dalsej obrazovke a priprav si svoje diokumenty The identity through your document (ID-card, pass ...). In next steps qui dolorum dolor sed prepare you ID card aliquid est possimus consectetur et excepturi.'
          }
        />
      </Typography>
      <Grid container justifyContent={'center'}>
        <FormControlLabel
          control={
            <Checkbox
              checked={checkboxState}
              onChange={() => setCheckboxState(!checkboxState)}
              color="primary"
              sx={{ borderRadius: '8px' }}
            />
          }
          label={
            <Typography fontWeight={500} fontSize={'14px'}>
              <Translate
                entityName={'customer.introduction.privacy'}
                defaultMessage={'I agree with'}
              />{' '}
              <Link
                href="https://dev-checkin-customer.netlify.app/privacy-policy/"
                target={'_blank'}
              >
                <Translate
                  entityName={'customer.introduction.privacy.link'}
                  defaultMessage={'privacy policy'}
                />
              </Link>
            </Typography>
          }
        />
      </Grid>
      <Grid container justifyContent={'center'}>
        <CustomContainedButton
          variant="contained"
          color="primary"
          sx={{ marginTop: matches ? '15px' : '5px' }}
          onClick={initializeCheckin}
          loading={buttonState}
          disabled={!checkboxState}
        >
          <Translate
            entityName={'customer.introduction.button'}
            defaultMessage={'Start check-in'}
          />
        </CustomContainedButton>
      </Grid>
    </Grid>
  )
}
